import React from "react";
import { TEMARIO } from "../../constants/temario";
import TopicCard from "./TopicCard";

const StudyLibrary = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-10 animate-fade">
      {TEMARIO.map((topic) => (
        <TopicCard key={topic.id} topic={topic} />
      ))}
    </div>
  );
};

export default StudyLibrary;
